import { useMemo } from "react";

import {
  LEADERBOARD_TIER_CHIP_ROW,
  leaderboardTierStatusChipClass,
  statusChipLabelClass,
  statusChipValueClass,
  statusChipValueUnitClass,
} from "../../Utils/Helper/discoveryHubUi";
import { computeLeaderboardTierChips } from "../../Utils/Helper/sponsorEngagementUi";

type LeaderboardTierKpiCardsProps = {
  rows: { tier?: string | null }[];
  className?: string;
};

const LeaderboardTierKpiCards = ({
  rows,
  className = "",
}: LeaderboardTierKpiCardsProps) => {
  const tierChips = useMemo(() => computeLeaderboardTierChips(rows), [rows]);

  return (
    <div className={`${LEADERBOARD_TIER_CHIP_ROW} ${className}`.trim()}>
      {tierChips.map(({ tier, count, pct }) => (
        <div key={tier} className={leaderboardTierStatusChipClass(tier)}>
          <div className={statusChipLabelClass}>{tier}</div>
          <div className={statusChipValueClass}>
            {count}
            <span className={statusChipValueUnitClass}>{pct}%</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default LeaderboardTierKpiCards;
